import { telephoneTypeIds } from './constants'

export const isValidNumberType = (numberType, telephoneTypeId) => {
  const id = telephoneTypeId?.toLowerCase()
  if (id === telephoneTypeIds.cellPhone)
    return numberType === 'MOBILE' || numberType === 'FIXED_LINE_OR_MOBILE'
  if (id === telephoneTypeIds.house || id === telephoneTypeIds.office)
    return numberType === 'FIXED_LINE' || numberType === 'FIXED_LINE_OR_MOBILE'
  return false
}
